const KNOWN_ROOT_SUFFIXES = [
  'inteligenciadevida.com.br',
  'inteligenciadevida.tec.br'
] as const;

export function getRootDomain(hostname: string): string | null {
  const normalized = hostname.toLowerCase();

  for (const suffix of KNOWN_ROOT_SUFFIXES) {
    if (normalized === suffix || normalized.endsWith(`.${suffix}`)) {
      return suffix;
    }
  }

  return null;
}

export function isSiblingSubdomain(
  targetHostname: string,
  appDomain: string
): boolean {
  const targetRoot = getRootDomain(targetHostname);
  const appRoot = getRootDomain(appDomain);

  if (!targetRoot || !appRoot || targetRoot !== appRoot) {
    return false;
  }

  return targetHostname.toLowerCase() !== appDomain.toLowerCase();
}
